"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ShapesDrawer;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactUseinterval = _interopRequireDefault(require("react-useinterval"));

var _shapes = require("../utils/shapes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ShapesDrawer({
  shapes,
  stroke,
  fill,
  timing
}) {
  const ref = (0, _react.useRef)();
  const [current, setCurrent] = (0, _react.useState)(null);
  const [play, setPlay] = (0, _react.useState)(timing);
  (0, _react.useEffect)(() => {
    init();
    window.addEventListener("resize", init);
    return () => window.removeEventListener("resize", init);
  }, []);
  (0, _reactUseinterval.default)(() => {
    const canvas = ref.current;

    if (canvas.getContext) {
      const context = canvas.getContext("2d");

      if (current !== null && current < shapes.length) {
        context.beginPath();

        if (shapes[current].shape) {
          (0, _shapes.drawShape)(canvas, context, shapes[current].shape);
        }

        if (shapes[current].inner) {
          (0, _shapes.drawShape)(canvas, context, shapes[current].inner);
        }

        context.closePath();
        context.stroke();
        context.fill("evenodd");
        setCurrent(current + 1);
      } else {
        setCurrent(null);
        setPlay(null);
      }
    }
  }, play);

  const init = () => {
    if (typeof window !== "undefined") {
      const canvas = ref.current;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      if (canvas.getContext) {
        const context = canvas.getContext("2d");
        context.strokeStyle = stroke;
        context.fillStyle = fill;
        context.imageSmoothingEnabled = true;

        if (shapes.length > 0) {
          setCurrent(0);
          setPlay(timing);
        }
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: ref
  });
}

ShapesDrawer.propTypes = {
  shapes: _propTypes.default.array.isRequired,
  stroke: _propTypes.default.string,
  fill: _propTypes.default.string,
  timing: _propTypes.default.number
};
ShapesDrawer.defaultProps = {
  shapes: [],
  stroke: "#000000",
  fill: "#ffffff",
  timing: 120
};